var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"display":"flex"}},[_c('el-button',{attrs:{"type":"primary","round":"","size":"small","icon":"el-icon-edit"},on:{"click":_vm.editCatalog}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }